import { config } from "src/config";
import Http from "./api.service";
import {
  CountriesListResponse,
  CtvQuartersListResponse,
  HcpListResponse,
  ProgramNumbersResponse,
} from "src/types/programFilters";
import { AffiliateProgramResponse } from "src/types/affiliatePrograms";

type ProgramParams = {
  countries?: string;
  hcps?: string;
  ctvquarters?: string;
  programnumbers?: string;
  page: number;
};

const AffiliateService = () => {
  const api = Http(false, config().baseBackendUrl + "/affiliate").instance;

  const getData = async (params: ProgramParams) => {
    console.log("programs service call");
    return await api
      .get<AffiliateProgramResponse>(`/programs`, {
        params,
      })
      .then((response) => {
        return response.data;
      });
  };

  const getCtvQuarters = async () => {
    return await api
      .get<CtvQuartersListResponse>(`/ctvquarters/`)
      .then((response) => {
        return response.data;
      });
  };

  const getCountries = async () => {
    return await api
      .get<CountriesListResponse>(`/countries/`)
      .then((response) => {
        return response.data;
      });
  };

  const getHcps = async () => {
    return await api.get<HcpListResponse>(`/hcps/`).then((response) => {
      return response.data;
    });
  };

  const getProgramNumbers = async () => {
    return await api
      .get<ProgramNumbersResponse>(`/programnumbers/`)
      .then((response) => {
        return response.data;
      });
  };

  api.interceptors.request.use((config) => {
    config.headers["Authorization"] = `Bearer ${sessionStorage.getItem(
      "eva_token"
    )}`;
    config.headers["Session"] = sessionStorage.getItem("eva_session");
    return config;
  });

  return { getData, getCtvQuarters, getCountries, getHcps, getProgramNumbers };
};

export default AffiliateService;
